import Axios from 'axios';
import { TutorSchedule } from '@/modules/schedule';
import { getDefaultSettings } from 'http2';

interface SearchCondition {
  id: number;
  tutorId: string;
  subjectId: number;
  isReservedOnly: boolean;
  headerTopDate: Date;
}

interface SimpleCalendarDate {
  id: number;
  date: Date;
}

// 型の Export
export {
  SimpleCalendarDate,
  SearchCondition,
};

interface State {
  isLoading: boolean;
  searchCondition: SearchCondition;
  dates: SimpleCalendarDate[];
}

const mapState = {
  isLoading: false,
  searchCondition: {
    id: 0,
    tutorId: '',
    subjectId: 0,
    isReservedOnly: false,
    headerTopDate: new Date(),
  },
};

const mapMutations = {
  setIsLoading(state: State, isLoading: boolean) {
    state.isLoading = isLoading;
  },

  setDates(state: State, dates: SimpleCalendarDate[]) {
    state.dates = [];
    dates.forEach((date: SimpleCalendarDate) => {
      date.date = new Date(date.date);
      state.dates.push(Object.assign({}, date));
    });
  },
};

const mapActions = {

  async getDatesRequest({ commit }: any) {
    const response = await Axios.post<SimpleCalendarDate[]>('/api/Calendar/SimpleCalendarDates')
      .catch((error) => {
        throw error;
      });
    if (response) {
      commit('setDates', response.data);
    }
  },
};

// ストアの Export
export default {
  namespaced: true,
  state: mapState,
  actions: mapActions,
  mutations: mapMutations,
};
